import { Select as AntdSelect, ConfigProvider, Tooltip } from "antd";
import { ReactComponent as DownArrow } from "../../assets/Icons/DownArrow.svg";
import "./Select.scss";

const CustomSelect = (props) => {
  const {
    label,
    placeholder = "Select an option",
    options = [],
    onChange,
    value,
    defaultValue,
    style = {},
    suffixIcon,
    isMultiSelect,
    selectTheme = {},
    showSearch = false,
    maxTagCount = "responsive",
    ...restProps
  } = props;

  const defaultSelectTheme = {
    colorPrimary: "#1890ff",
    fontSize: 14,
    controlHeight: 36,
    optionSelectedBg: "#f0f0f0",
  };

  const mergedTheme = {
    components: {
      Select: {
        ...defaultSelectTheme,
        ...selectTheme,
      },
    },
  };

  const renderMaxTagPlaceholder = (omittedValues) => (
    <Tooltip title={omittedValues.map(({ label }) => label).join(", ")}>
      <span>+{omittedValues.length} more</span>
    </Tooltip>
  );

  return (
    <div className="select-main">
      {label && <label className="upper-label">{label}</label>}

      <ConfigProvider theme={mergedTheme}>
        <AntdSelect
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          value={value}
          defaultValue={defaultValue}
          suffixIcon={suffixIcon || <DownArrow />}
          dropdownClassName="custom-select-dropdown"
          style={{ width: "100%", minHeight: 36, ...style }}
          dropdownStyle={{ maxHeight: "none", minHeight: 40 }}
          mode={isMultiSelect ? "multiple" : undefined}
          maxTagCount={maxTagCount}
          maxTagPlaceholder={renderMaxTagPlaceholder}
          showSearch={showSearch}

          {...restProps}
        />
      </ConfigProvider>
    </div>
  );
};

export default CustomSelect;
